import { Box, Button } from '@mui/material'
import { userRoles } from 'constant'
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid'
import { useContext, useState } from 'react'
import { UserContext } from 'contexts/UserContextProvider'
import Header from 'components/Header'
import { deleteUser } from 'api'
import EditUserForm from './EditUserForm'

enum FormAction {
  Create = 'create',
  Edit = 'edit'
}

const UserList = () => {
  const { users, setUsers, loading, setSelectedUser } = useContext(UserContext)
  const [openUserForm, setOpenUserForm] = useState(false)
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10
  })
  const [formAction, setFormAction] = useState<FormAction>(FormAction.Create)
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 250 },
    { field: 'username', headerName: 'Username', width: 150 },
    { field: 'email', headerName: 'Email', width: 150 },
    { field: 'company', headerName: 'Company', width: 150 },
    {
      field: 'role',
      headerName: 'Role',
      width: 250,
      valueFormatter: (params: string) => {
        if (!params) return ''
        const matched = userRoles.find(r => r.value === params)
        return matched ? matched.label : params
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 300,
      sortable: false,
      renderCell: (params: any) => (
        <>
          <Button
            variant='outlined'
            size='small'
            onClick={() => {
              setSelectedUser(params.row)
              setFormAction(FormAction.Edit)
              setOpenUserForm(true)
            }}
            sx={{ mr: 1 }}
          >
            Edit
          </Button>
          <Button
            variant='outlined'
            size='small'
            onClick={() => {
              handleDeleteUser(params.row._id)
            }}
          >
            Delete
          </Button>
        </>
      )
    }
  ]
  const handleDeleteUser = async (userId: string) => {
    try {
      await deleteUser(userId)
      setUsers(users.filter(user => user._id !== userId))
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <>
      <Header />
      <Box sx={{ height: 600, width: '90%', margin: '20px auto' }}>
        <DataGrid
          rows={users}
          columns={columns}
          loading={loading}
          slotProps={{
            loadingOverlay: {
              variant: 'skeleton',
              noRowsVariant: 'skeleton'
            }
          }}
          pageSizeOptions={[5, 10, 20]}
          paginationModel={paginationModel}
          onPaginationModelChange={newPaginationModel =>
            setPaginationModel(newPaginationModel)
          }
          disableRowSelectionOnClick
        />
      </Box>
      <Button
        variant='contained'
        color='primary'
        style={{
          display: 'block',
          margin: '20px auto',
          padding: '10px 20px',
          fontSize: 20
        }}
        onClick={() => {
          setFormAction(FormAction.Create)
          setOpenUserForm(true)
        }}
      >
        Create New User
      </Button>
      <EditUserForm
        openUserForm={openUserForm}
        setOpenUserForm={setOpenUserForm}
        formAction={formAction}
      />
    </>
  )
}

export default UserList
